export default "__VITE_ASSET__CUrySl9D__"